<template>
 <v-main >
  <div class="bg-red pb-8"> 
    <v-container>
      <v-row class="text-center">
        <v-col cols="12">
        <h2 class="text-white">Apóyanos en nuestra labor</h2>
        <p class="text-center cuerpo-texto white--text"><!--Lorem ipsum dolor sit amet consectetur adipisicing elit. Quibusdam <br>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quibusdam ullam fugit--></p>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="12" xs="12">
          <v-card class="pa-5 bg-white text-center rounded">
              <h3> Participan</h3>
              <hr class="hr-k my-3 rounded-0">
              <v-row class="align-center">
                <v-col 
                v-for="(item,i) in items"
                cols="2"
                :key="i"
                >
                  <img class="img-gray img-fluid" :src="item.src">
                </v-col>
              </v-row>
          </v-card>  
        </v-col>
          
        <!--<v-col cols="12" sm="12" xs="12">
          <v-card class="pa-5 bg-white text-center rounded">
              <h3> Colaboradores</h3>
              <hr class="hr-k my-3 rounded-0">
              <v-row class="align-center">
                <v-col 
                v-for="(item,c) in colab"
                cols="2"
                :key="c"
                >
                  <v-img class="img-gray" :src="item.src"></v-img>
                </v-col>
              </v-row>

          </v-card>
        </v-col>-->
      </v-row>
    </v-container>
  </div> 
  </v-main>
</template>

<script>
export default {
  name: 'SupportUs', 
  data() {
  return {
    items: [
      { src: require('../assets/support/corfo.png') },
      { src: require('../assets/support/fcfm-2.jpg') },
      { src: require('../assets/support/pfizer.png') },
      { src: require('../assets/support/untec.png') },
      { src: require('../assets/support/uchile.png') },
      { src: require('../assets/support/wic.png') },
      { src: require('../assets/support/ing.jpg') },
      { src: require('../assets/support/novartis.png') },
      { src: require('../assets/support/sociedad-chilena.png') },
      { src: require('../assets/support/coamisal.jpg') },
      { src: require('../assets/support/medicina.png') },
      { src: require('../assets/support/fricke.png') },
      { src: require('../assets/support/hso.gif') },
      { src: require('../assets/support/labchile-teva.png') },
      { src: require('../assets/support/sancamilo.png') },
      { src: require('../assets/support/sanjose.png') },
      { src: require('../assets/support/anid.png') },
      { src: require('../assets/support/salvador.png') },
      { src: require('../assets/support/1SSMNorte.jpg') },
      { src: require('../assets/support/ssmo.jpg') }
    ],
  }
  }
}
</script>

<style scoped lang="sass">
  .bg-red
    h2
      font-size: 2em
  .rounded
    h3
      font-size: 1.5em

  .img-gray 
    filter: grayscale(1)
    transition-property: filter, opacity
    transition-duration: 1s
    opacity: 0.5

    &:hover
      filter: grayscale(0)
      transition-property: filter, opacity
      transition-duration: 1s
      opacity: 1
          

</style>